import React, { ReactElement } from 'react';
import { Disclaimer, GridCol, GridRow, Link } from '@lmig/lmds-react';
import styles from './footer-component.module.scss';
import CaliforniaPrivacyChoices from './california-privacy-choices-component';

const FooterComponent: React.FC = (): ReactElement => {
  return (
    <GridRow id="claim-information-footer" className={styles.footer}>
      <GridCol md={10} sm={12}>
        <Disclaimer>
          <nav>
            <ul>
              <li>
                <Link
                  data-name="Footer-PrivacyPolicy-Link"
                  variant="navigational"
                  onBackground="blue"
                  href="https://libertymutualgroup.com/about-lm/corporate-information/privacy-policy"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  data-name="Footer-SecurityPolicy-Link"
                  variant="navigational"
                  onBackground="blue"
                  href="https://libertymutualgroup.com/about-lm/corporate-information/security-policy"
                >
                  Security Policy
                </Link>
              </li>
              <li>
                <Link
                  data-name="Footer-TermsAndConditions-Link"
                  variant="navigational"
                  onBackground="blue"
                  href="https://libertymutualgroup.com/about-lm/corporate-information/terms-and-conditions"
                >
                  Portal Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  data-name="Footer-FraudProtection-Link"
                  variant="navigational"
                  onBackground="blue"
                  href="https://libertymutualgroup.com/about-lm/corporate-information/fraud-protection-tips"
                >
                  Fraud Protection
                </Link>
              </li>
              <li>
                <Link
                  data-name="Footer-EService-Paperless-Terms-Link"
                  variant="navigational"
                  onBackground="blue"
                  href="http://public.libertymutual-cdn.com/PmEService/MediaAssets/pages/terms-and-conditions-paperless.html?exp=dk"
                >
                  eService and Paperless Terms and Conditions
                </Link>
              </li>
            </ul>
            <CaliforniaPrivacyChoices />
          </nav>
          <p>
            © {new Date().getFullYear()} Liberty Mutual Insurance Company, 175
            Berkeley Street, Boston, MA 02116
          </p>
        </Disclaimer>
      </GridCol>
      <GridCol md={2} sm={12} className={styles.imageWrapper}>
        <img
          src="data:image/gif;base64,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"
          alt="Better Business Bureau"
          className="footerImg"
        />
      </GridCol>
    </GridRow>
  );
};

export default FooterComponent;
